<template>
    <header class="topbar">
        <div class="row topbarRow">
        <div class="col-1 logoCol">
            <div class="logoHeader">
                <router-link to="/">
                    <img alt="QRCodeExperts.net" src="../assets/logo-qrcodeexperts.png" class="logo" />
                </router-link>
                <div class="logoHeaderText">
                    <div v-if="ownername || ownerusername" class="welcomeLine">
                        <small>Welcome {{ ownername || ownerusername }}</small>
                    </div>
                    <div class="versionLine">
                        <small>UI: v{{ appVersion }}<template v-if="apiVersion"> · API: v{{ apiVersion }}</template></small>
                    </div>
                    <div class="versionLine">
                        <small>Local: {{ localTimeDisplay }}</small>
                    </div>
                    <div class="versionLine">
                        <small>UTC: {{ utcTimeDisplay }}</small>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-11 navCol">
            <div class="row">
                <div class="col-12">
                    <div class="col-11">
                        <Navbar :key="$route.fullPath" />
                    </div>
                </div>
            </div>
        </div>
        </div>
    </header>
</template>

<script>
import Navbar from "./Navbar.vue"
import { getUser, getUserFullNameFromApi } from "../libs/libs.js"
import { getAuth, isAuthenticated, onAuthChanged } from "@/libs/auth"
import { apiFetchJson } from "@/libs/api"
import packageJson from "../../package.json"

export default {
    components: { Navbar },
    data() {
        return {
            outputFormat: this.$route.query.of,
            user: null,
            owneruserid: null,
            ownerusername: null,
            ownername: null,
            theAuthCookie: getAuth(),
            componentKey: 0,
            removeAuthChangedListener: null,
            appVersion: packageJson.version,
            apiVersion: "",
            now: new Date(),
            clockTimerId: null,
        }
    },
    computed: {
        localTimeDisplay() {
            return this.formatDateTime(this.now, {
                timeZoneName: "short",
                timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            })
        },
        utcTimeDisplay() {
            return this.formatDateTime(this.now, {
                timeZone: "UTC",
                timeZoneName: "short",
            })
        },
    },
    watch: {
        "$route.fullPath"() {
            this.refreshAuth()
        }
    },
    mounted() {
        this.refreshAuth()
        this.loadApiVersion()
        this.clockTimerId = window.setInterval(() => {
            this.now = new Date()
        }, 1000)
        this.removeAuthChangedListener = onAuthChanged(() => this.refreshAuth())
        if (this.outputFormat == 1) {
            console.log("toprow outputFormat 1")
        }
    },
    beforeUnmount() {
        if (this.removeAuthChangedListener) this.removeAuthChangedListener()
        if (this.clockTimerId) window.clearInterval(this.clockTimerId)
    },
    methods: {
        formatDateTime(value, options = {}) {
            return new Intl.DateTimeFormat("en-US", {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false,
                ...options,
            }).format(value)
        },
        async loadApiVersion() {
            try {
                const health = await apiFetchJson("/healthz", {}, { auth: false })
                this.apiVersion = typeof health?.version === "string" ? health.version : ""
            } catch (error) {
                this.apiVersion = ""
                console.warn("Unable to load API version", error)
            }
        },
        refreshAuth() {
            this.theAuthCookie = getAuth()
            if (!isAuthenticated()) {
                this.user = null
                this.owneruserid = null
                this.ownerusername = null
                this.ownername = null
                return
            }
            this.setupAuthInfo(this.theAuthCookie)
        },
        async setupAuthInfo(authInfo) {
            if (!(authInfo && authInfo.userId && isAuthenticated())) return
            this.user = await getUser(authInfo.userId)
            if (!this.user) return
            this.owneruserid = this.user.id
            this.ownerusername = this.user.username
            this.ownername = getUserFullNameFromApi(this.user)
        },
        forceRerender() {
            //this.theAuthCookie = buildAuth();
            this.refreshAuth()
            this.componentKey += 1;
        }
    }

}
</script>

<style>
.topbar {
    position: sticky;
    top: 0;
    z-index: 10;
    background: #b0b9bb;
    border-bottom: 1px solid var(--qrce-border);
    box-shadow: 0 6px 18px rgba(15, 23, 42, 0.06);
}
.topbarRow {
    padding: 10px 6px;
}
.logo {
    width: 80px;
}
.logoCol {
    flex: 0 0 24%;
    max-width: 24%;
}
.navCol {
    flex: 0 0 76%;
    max-width: 76%;
}
.logoHeader {
    display: flex;
    align-items: center;
    gap: 10px;
}
.logoHeaderText {
    text-align: left;
    overflow-wrap: anywhere;
    min-width: 0;
    color: var(--qrce-muted);
    display: grid;
    gap: 2px;
}
.welcomeLine {
    font-size: 1.05em;
    line-height: 1.1;
}

.versionLine {
    font-size: 0.92em;
    line-height: 1.1;
    opacity: 0.8;
}

@media (max-width: 819px) {
    .topbarRow {
        padding: 10px 10px;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
    }
    .logoCol,
    .navCol {
        flex: 0 0 auto;
        max-width: none;
    }
    .navCol {
        flex: 1 1 auto;
        margin-top: 0;
    }
    .logoHeaderText {
        display: none;
    }
}
</style>
